<template>
  <Container class="IndexPageLayout">
    <div class="withSidebar">
      <div class="sidebar">
        <slot name="sidebar" />
      </div>
      <div class="slot">
        <slot />
      </div>
    </div>
    <slot name="bottom" />
  </Container>
</template>

<script>
export default {}
</script>

<style scoped>

.IndexPageLayout {
  padding-top: var(--spacing-11);
  padding-bottom: var(--spacing-17);
}

.sidebar + .slot,
.slot + .sidebar {
  margin-top: var(--spacing-12);
}

@media (--screen-lg) {
  .withSidebar {
    display: grid;
    gap: var(--spacing-7);
    /* Using minmax here prevents column width being pushed out by contents */
    grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);
  }
  .sidebar + .slot,
  .slot + .sidebar {
    margin-top: 0;
  }
}
</style>
